import { type ReactNode, useEffect } from 'react';

type Props = { title?: string; children: ReactNode };

const APP_NAME = 'Time Tracker';

export const RoutePage: React.FC<Props> = ({ title, children }) => {
    useEffect(() => {
        document.title = title ? `${title} — ${APP_NAME}` : APP_NAME;
        return () => {
            document.title = APP_NAME;
        };
    }, [title]);
    return children;
};
